import { all, fork } from 'redux-saga/effects'

import AlertSaga from './AlertSaga'

export default function* alertsSagas() {
  yield all([fork(new AlertSaga().supervise)])
}
